import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { VehicleModelsService } from "../vehicle-models/vehicle-models.service";
import { DataService } from "../data.service";
import { ConstantsService } from "../constants.service";
import { ToastMessage } from "../toast-message/toast-message.service";
import { HostService } from "./host.service";

@Component({
  selector: "app-host-vehicle-model-create",
  template: require('./host-vehicle-model-create.component.html'),
})
export class HostVehicleModelCreateComponent implements OnInit {
  manufacturer = "";
  model = "";
  displayName = "";
  modeId = "";
  modes: Array<{ _id: string; mode: string }> = [];
  isLoadingModes = true;
  type = "";
  typeOptions: string[] = [];
  isSubmitting = false;

  constructor(
    private router: Router,
    private hostService: HostService,
    private vehicleModelsService: VehicleModelsService,
    private dataService: DataService,
    private constantService: ConstantsService,
    private toast: ToastMessage,
  ) {}

  ngOnInit() {
    this.loadModes();
  }

  onBack() {
    this.router.navigate(["/hostSearch"]);
  }

  onModeChange() {
    this.recomputeTypeOptions();
  }

  canSubmit(): boolean {
    const hasVal = (s: string) => !!(s && s.trim().length);
    const basicOk =
      hasVal(this.manufacturer) &&
      hasVal(this.model) &&
      hasVal(this.displayName) &&
      hasVal(this.modeId);
    const typeOk = this.typeOptions.length ? hasVal(this.type) : true;
    return !!(basicOk && typeOk) && !this.isSubmitting;
  }

  onSubmit() {
    if (!this.canSubmit()) {
      return;
    }

    const addRole = this.constantService.vehicleModelPermissions.add;
    const accessRoles = this.dataService.accessCookie("accessRoles") || "";
    const roles = accessRoles ? accessRoles.split(",") : [];
    if (roles.indexOf(addRole) === -1) {
      this.toast.openSnackBarError(
        "You are not authorized to add vehicle models",
      );
      return;
    }

    const payload: any = {
      manufacturer: this.manufacturer.trim(),
      model: this.model.trim(),
      displayName: this.displayName.trim(),
      modeId: this.modeId,
      active: false,
    };
    if (this.typeOptions.length && this.type && this.type.trim().length) {
      payload.bodyType = this.type;
    }

    this.isSubmitting = true;
    this.vehicleModelsService.createVehicleModel(payload).subscribe(
      (res: any) => {
        this.isSubmitting = false;
        if (res && res.success) {
          this.toast.openSnackBarSuccess("Vehicle model created");
          this.router.navigate(["/hostSearch"]);
        } else {
          this.toast.openSnackBarError("Failed to create vehicle model");
        }
      },
      () => {
        this.isSubmitting = false;
        this.toast.openSnackBarError("Failed to create vehicle model");
      },
    );
  }

  private loadModes() {
    this.isLoadingModes = true;
    this.hostService.getHostConfig().subscribe(
      (cfg) => {
        const validIds = new Set(cfg.validPoolModeIds);
        const userId = localStorage.getItem("userId") || "system";
        this.hostService.getModes(userId).subscribe(
          (allModes) => {
            this.isLoadingModes = false;
            this.modes = allModes.filter((m: any) => validIds.has(m._id));
            this.recomputeTypeOptions();
          },
          () => {
            this.isLoadingModes = false;
          },
        );
      },
      () => {
        this.isLoadingModes = false;
      },
    );
  }

  private recomputeTypeOptions() {
    const found = this.modes.find((m) => m._id === this.modeId);
    const modeName = (found && found.mode ? found.mode : "").toLowerCase();
    if (modeName === "bike") {
      this.typeOptions = ["scooty", "Bike"];
    } else if (modeName === "car") {
      this.typeOptions = ["Hatchback", "Sedan", "SUV", "Compact SUV"];
    } else if (modeName === "auto") {
      this.typeOptions = ["E-rickshaw", "Auto Rickshaw"];
    } else {
      this.typeOptions = [];
    }
    if (this.typeOptions.length && this.typeOptions.indexOf(this.type) === -1) {
      this.type = "";
    }
  }
}
